import type { Pagination } from './Common'
import type { VariableType } from './Configurator'

// Keep in sync with bff/src/api/variables/variables.constants.ts.
export const MAX_VARIABLE_NAME_LENGTH = 64

export interface GlobalVariable {
  id: string
  name: string
  type: VariableType
  fallbackValue: string
  description?: string
}

export interface VariablesListResponse {
  variables: GlobalVariable[]
  pagination: Pagination
}

export const variableTypeOptions: { label: string; value: VariableType }[] = [
  { label: 'String', value: 'string' },
  { label: 'Int', value: 'int' },
  { label: 'Float', value: 'float' },
  { label: 'Boolean', value: 'boolean' },
  { label: 'Array[string]', value: 'array_string' },
  { label: 'Array[int]', value: 'array_int' },
]
